<template>
  <div>
    <div class="m-service-header">
      <div class="service-h-inner clearfix">
        <div class="h-inner-txt">
          <h2>{{ $t('about_service') }}</h2>
          <p class="h-txt" v-html="$t('nanacara_for_doctor_is_for_patients')">​</p>
        </div>
        <div class="h-inner-pic">
          <p><img width="515" :src="$t('image.info.pic_service01')" alt=""></p>
        </div>
      </div>
    </div>
    <div id="m-service-contents">
      <div class="m-contents-main pt30">
        <p class="center mb50"><img width="800" :src="$t('image.info.service.1')" alt=""></p>
      </div>

      <div class="m-contents-before">
        <div class="c-before-inner">
          <h2>{{ $t('before_using_the_service') }}</h2>
          <p>{{ $t('make_sure_js_is_enabled') }}</p>
          <p>{{ $t('please_make_sure_that_cookies_are_enabled') }}</p>
        </div>
      </div>

      <div class="m-contents-main pt30">
        <h2 class="s-main-ttl">{{ $t('service_function_description') }}</h2>
        <div class="bottom-border"></div>
        <h3><span>01</span>{{ $t('otp') }}</h3>

        <p class="txt-indent">{{ $t('if_you_enter_the_password_presented_to_the_patient_nanacara_app') }}</p>
        <p class="txt-indent">{{ $t('data_viewing_is_valid_for_2_hours') }}</p>
        <p class="txt-indent">{{ $t('if_you_want_to_view_the_data_of_the_next_patient') }}</p>
        <p class="txt-indent">{{ $t('if_you_want_to_return_to_the_previous_patient') }}</p>
        <p class="txt-indent">{{ $t('if_the_app_user_stops_using_the_otp') }}</p>
        <p class="txt-indent mb30">{{ $t('if_the_site_does_not_open') }}</p>

        <p class="center mb50"><img width="800" :src="$t('image.info.service.2')" alt=""></p>

        <h3><span>02</span>{{ $t('patient_information') }}</h3>

        <p class="ml10 mb20">{{ $t('the_patient_information_registered_in_the_nanacara_app_is_displayed') }}</p>

        <p>{{ $t('display_content') }}</p>
        <p class="txt-indent">{{ $t('dot_name') }}</p>
        <p class="txt-indent">{{ $t('dot_gender') }}</p>
        <p class="txt-indent">{{ $t('dot_age') }}</p>
        <p class="txt-indent">{{ $t('dot_symptom_name') }}</p>
        <p class="txt-indent">{{ $t('dot_types_of_seizures') }}</p>
        <p class="txt-indent">{{ $t('dot_average_number_of_seizures_info') }}</p>
        <p class="txt-indent mb30">{{ $t('dot_medication_history') }}</p>

        <p class="center mb50"><img width="800" :src="$t('image.info.service.3')" alt=""></p>

        <h3><span>03</span>{{ $t('seizures_count_graph') }}</h3>

        <p class="ml10 mb20">{{ $t('you_can_view_the_seizure_count_graph_recorded_by_the_patient') }}</p>

        <p class="txt-indent">{{ $t('the_seizure_graph_can_be_changed_to_a_graph_for_each_seizure_type') }}</p>
        <p class="txt-indent">{{ $t('the_medicine_you_are_taking_is_displayed_as_a_bar_at_the_bottom_of_the_graph') }}</p>
        <p class="txt-indent mb30" v-html="$t('the_presence_or_absence_of_medication_at_the_time_of_seizure_is_marked', {img: `<img src='/common/img/icon_video.png' alt=''>`})"></p>

        <p class="center mb50"><img width="800" :src="$t('image.info.service.4')" alt=""></p>

        <h3><span>04</span>{{ $t('video') }}</h3>

        <p class="ml10 mb30">{{ $t('of_the_seizure_images_taken_and_saved_by_the_patient') }}</p>

        <p class="center mb50"><img width="800" :src="$t('image.info.service.5')" alt=""></p>

        <h3><span>05</span>{{ $t('pdf_output') }}</h3>

        <p class="ml10 mb30">{{ $t('patient_information_medication_history_and_seizure_graph_can_be_output_as_pdf') }}</p>

        <p class="center"><img width="800" :src="$t('image.info.service.6')" alt=""></p>

      </div>

    </div>
  </div>
</template>

<script>
  export default {
    mounted() {
      this.screenTracking(this.$t('about_service'))
    }
  }
</script>
